import React, { FC } from 'react';

import s from './index.scss';

// TODO: remove when it close 'specs.funnel.templatePageUiV2'
export const DealerBannerNew: FC = () => {
  return (
    <div className={s.container}>
      <span className={s.title}>Want Help Picking a Template?</span>
      <span className={s.description}>Get tips for finding the template that’s right for you</span>
      <a
        href="https://support.wix.com/en/article/choosing-the-best-template-for-your-site"
        className={s.link}
        target="_blank"
      >
        Help Me Choose
      </a>
    </div>
  );
};
